import { render, staticRenderFns } from "./FlagAction.vue?vue&type=template&id=16a78044&"
import script from "./FlagAction.vue?vue&type=script&lang=js&"
export * from "./FlagAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports